// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__+OD5p","infected":"Cards_infected__j6dVe","recovered":"Cards_recovered__py7wZ","deaths":"Cards_deaths__qudY+"};